import React, { useEffect } from 'react';
import { Col, Row, Select } from 'antd';
import usePujaStore from '@/modules/monetisation/puja/stores/puja-store';

interface StoreFilterProps {
    currentStep: number
}
const storeExp = ["puja_l2_creatives_80_20", "puja_l2_specificity_80_20", "puja_l2_creatives_95_5", "puja_l2_description_80_20"]
const inventoryExp = ["value_offering_experiments", "packages_content_experiment", "puja_packages_price", "add_ons_positioning", "add_ons_pricing", "add_ons_content_experiment"]
const pujaBenefitsExp = ["pooja_store_content_v1"]
const StoreFilter: React.FC<StoreFilterProps> = ({ currentStep }) => {
    const { experiment, setExperiment, variant, setVariant } = usePujaStore()
    useEffect(() => {
        if (experiment) {
            setVariant('VARIANT');
        } else {

            setVariant(undefined);
        }
    }, [experiment, setVariant]);

    const renderOptions = () => {
        switch (currentStep) {
            case 0:
                return storeExp?.map((exp: string) => <Select.Option value={exp}>{exp}</Select.Option>)
            case 1:
                return inventoryExp?.map((exp: string) => <Select.Option value={exp}>{exp}</Select.Option>)
            case 2:
                return pujaBenefitsExp?.map((exp: string) => <Select.Option value={exp}>{exp}</Select.Option>)
        }
    }
    return (
        <Row justify='space-between' style={{ width: "100%" }}>
            <span>Create Store</span>
            <Col>
                <label>Experiment</label>
                <Select placeholder="Select experiment" allowClear value={experiment} onChange={(value) => {
                    setExperiment(value)
                    setVariant('VARIANT');
                }} style={{ width: '200px', paddingLeft: '10px' }}>
                    {/* <Select.Option value="pooja_store_content_v1">pooja_store_content_v1</Select.Option>
                    <Select.Option value="puja_l2_creatives_80_20">puja_l2_creatives_80_20</Select.Option>
                    <Select.Option value="puja_l2_creatives_95_5">puja_l2_creatives_95_5</Select.Option>
                    <Select.Option value="puja_l2_description_80_20">puja_l2_description_80_20</Select.Option>
                    <Select.Option value="puja_l2_specificity_80_20">puja_l2_specificity_80_20</Select.Option>

                    <Select.Option value="value_offering_experiments">value_offering_experiments</Select.Option>
                    <Select.Option value="packages_content_experiment">packages_content_experiment</Select.Option>
                    <Select.Option value="puja_packages_price">puja_packages_price</Select.Option>
                    <Select.Option value="add_ons_positioning">add_ons_positioning</Select.Option>
                    <Select.Option value="add_ons_pricing">add_ons_pricing</Select.Option>
                    <Select.Option value="add_ons_content_experiment">add_ons_content_experiment</Select.Option>
                    <Select.Option value="puja_cms_packages_exp">puja_cms_packages_exp</Select.Option> */}
                    {renderOptions()}

                </Select>
                <label style={{ paddingLeft: '30px' }}>Variant</label>
                <Select disabled={!experiment} placeholder="Select variant" allowClear value={variant} onChange={(value) => { setVariant(value) }} style={{ width: '200px', paddingLeft: '10px' }}>
                    <Select.Option value="CONTROL" disabled>CONTROL</Select.Option>
                    <Select.Option value="VARIANT">VARIANT</Select.Option>
                </Select>
            </Col>
        </Row>
    )
}

export default React.memo(StoreFilter);